import { useState } from 'react';
import { trackDesignSystemAction } from 'analytics';
import ColorButton from 'components/Widget/Button/ColorButton';
import Lightbox, { type LightboxItem } from 'components/Widget/Lightbox';
import type { ShowcaseDesignSystem } from '../index';
import * as S from './styles';

interface ShowcaseCardProps {
	item: ShowcaseDesignSystem;
	onUse: (item: ShowcaseDesignSystem) => void;
	mode: 'select' | 'view';
}

const ShowcaseCard = ({ item, onUse, mode }: ShowcaseCardProps) => {
	const [lightboxItems, setLightboxItems] = useState<LightboxItem[]>([]);

	return (
		<S.Base>
			<S.Preview
				onClick={() => {
					const url = item.hiResImageUrl || item.imageUrl;
					if (url) setLightboxItems([{ type: 'image', url }]);
				}}
			>
				{item.imageUrl && <S.PreviewImage src={item.imageUrl} alt={item.title} />}
			</S.Preview>
			<Lightbox items={lightboxItems} onClose={() => setLightboxItems([])} />
			<S.Body>
				<S.Info>
					<S.Name>{item.title}</S.Name>
					{item.metadata && <S.Metadata>{item.metadata}</S.Metadata>}
					<S.Description>{item.description}</S.Description>
					{item.tags.length > 0 && (
						<S.Tags>
							{item.tags.map((tag) => (
								<S.Tag key={tag}>{tag}</S.Tag>
							))}
						</S.Tags>
					)}
					<S.Links>
						{mode === 'select' && (
							<>
								<S.Link
									href={item.dsUrl}
									target="_blank"
									rel="noopener noreferrer"
									onClick={() =>
										trackDesignSystemAction('gallery_view_ds', {
											dsId: item.designSystemId,
											dsName: item.title,
										})
									}
								>
									View DS
								</S.Link>
								{item.projectUrl && <S.LinkSeparator>·</S.LinkSeparator>}
							</>
						)}
						{item.projectUrl && (
							<S.Link
								href={item.projectUrl}
								target="_blank"
								rel="noopener noreferrer"
								onClick={() =>
									trackDesignSystemAction('gallery_view_project', {
										dsId: item.designSystemId,
										dsName: item.title,
									})
								}
							>
								{mode === 'view' ? 'View Sample Project' : 'View Project'}
							</S.Link>
						)}
					</S.Links>
				</S.Info>
				<S.ActionArea>
					<ColorButton
						label={mode === 'view' ? 'View DS' : 'Use DS'}
						color="blue"
						size="small"
						onClick={() => {
							trackDesignSystemAction(mode === 'view' ? 'gallery_view_ds' : 'gallery_use_ds', {
								dsId: item.designSystemId,
								dsName: item.title,
							});
							onUse(item);
						}}
					/>
				</S.ActionArea>
			</S.Body>
		</S.Base>
	);
};

export default ShowcaseCard;
